// The cat at home in its bed (the app's corner while the desktop cat is hidden, and the web app): it stays put and only does what a
// cat does in place — sits, yawns, curls up, sleeps, wakes up again. A tiny player of its own, no world and no brain: just the next
// clip by weight from the pose it is in.

/** Clips it may play in the bed, by the pose they start from: [clip, weight] (a number alone: holding still for that many seconds). */
const ROUTINE = {
  sit: [[4, 3], [7, 2], ['sit__yawn__sit', 1.2], ['sit__curlup__curl', 1]],
  curl: [['curl__sleep__curl', 3], ['curl__sleep_bubble__curl', 1.2], ['curl__wakeup__sit', 0.6]],
};
/** The clips the bed needs (for loading only these). */
export const BED_CLIPS = [...new Set(Object.values(ROUTINE).flatMap((list) => list.map(([c]) => c).filter((c) => typeof c === 'string')))];

export class BedCat {
  /** clips: the manifest's clip entries (at least BED_CLIPS); start: the pose it starts in. */
  constructor(clips, start = 'curl') {
    this.clips = new Map(clips.map((c) => [c.name, c]));
    this.pose = start;
    this.next();
  }

  /** Pick what comes next from the pose it is in. */
  next() {
    const options = ROUTINE[this.pose].filter(([c]) => typeof c === 'number' || this.clips.has(c));
    let r = Math.random() * options.reduce((s, [, w]) => s + w, 0);
    const [pick] = options.find(([, w]) => (r -= w) < 0) ?? options[0];
    if (typeof pick === 'number') {
      // Holding still: the first frame of a clip from this pose
      const still = [...this.clips.values()].find((c) => c.from === this.pose);
      this.play = { clip: still, hold: pick * (0.7 + Math.random() * 0.6), t: 0 };
    } else this.play = { clip: this.clips.get(pick), t: 0 };
  }

  tick(dt) {
    const p = this.play;
    p.t += dt;
    const done = p.hold != null ? p.t >= p.hold : p.t * p.clip.fps >= p.clip.frames;
    if (done) {
      if (p.hold == null) this.pose = p.clip.to;
      this.next();
    }
  }

  /** The clip and frame to draw now. */
  view() {
    const p = this.play;
    return { clip: p.clip, frame: p.hold != null ? 0 : Math.min(p.clip.frames - 1, Math.floor(p.t * p.clip.fps)) };
  }
}
